<template>
  <div class="bg-surface-50 dark:bg-surface-950 min-h-screen px-12 py-20 md:px-12 lg:px-20">
    <slot />
  </div>
</template>
